const contentfulEntriesForErrorCode = {
  serverError: 'api_errors.cancellation_unexpected_error',
  default: 'api_errors.cancellation_appointment_error',
}

export const getCancellationErrorContentfulEntry = (statusCode: number) => {
  if (statusCode === 500) {
    return contentfulEntriesForErrorCode.serverError
  }
  return contentfulEntriesForErrorCode.default
}
